import type {UrlString} from '../types';

/**
 * This is used to check an avatar image after it loads, to ensure that it is
 * not a 1px blank "placeholder" image, which is what our server sends if it
 * cannot locate an actual image to use.
 *
 * Ref: NUT-7541
 *
 * @param  {string} url The url from the server
 * @return {string}     Either the input url, or empty quotes (if it is 1px)
 */
export function getAvatarUrl(url: UrlString): Promise<string> {
    return new Promise((resolve) => {
        const avatarImage = new Image();
        avatarImage.addEventListener('load', () => {
            try {
                const avatarUrl = avatarImage.naturalHeight === 1 ? '' : url;
                resolve(avatarUrl);
            } catch (e: any) {
                resolve('');
            }
        });
        avatarImage.src = url;
    });
}
